import { media, styled, typography } from '@pulse-web-ui/theme';

export const Item = styled.li`
  ${typography.medium16}
  position: relative;
  list-style: none;
  box-sizing: border-box;
  height: 112px;
  padding: 12px 12px 0 12px;
  background-color: ${({ theme }) => theme.colors.surface.secondary};
  border-radius: calc(${({ theme }) => theme.common.radius} * 3);
  cursor: pointer;
  overflow: hidden;

  ${media.desktop} {
    width: 168px;
  }
`;

export const Icon = styled.img`
  position: absolute;
  bottom: -12px;
  right: -12px;
  width: 84px;
  height: 84px;
`;

export const Badge = styled.span`
  ${typography.regular14}
  padding: 0 6px;
  line-height: 20px;
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.surface.primary};
  border-radius: calc(${({ theme }) => theme.common.radius} * 2);
`;
